module.exports = __webpack_public_path__ + "static/img/img01.ba64659.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/aifv/img01.png
// module id = Gi0u
// module chunks = 1